import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';

@Component({
	selector: 'vias-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit, OnChanges {
	@Input() item: FormItem;
	@Input() form: FormGroup;
	@Output() onclick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
	@Output() onchange: EventEmitter<object> = new EventEmitter<object>();
	filteredOptions: Observable<object[]>;
	myControl: FormControl;
	constructor() { }
	ngOnInit(): void {
		this.myControl = this.form.get(this.item.name) as FormControl;
		this.filteredOptions = this.myControl.valueChanges.pipe(
			startWith(''),
			debounceTime(300),
			map(value => {
				if (typeof value === 'string' && value.length < 2) return [];
				return this._filter(value);
			})
		);
	}
	onClick($event: MouseEvent): void {
		this.onclick.emit($event);
	}
	ngOnChanges(changes): void {
		// console.log('+___+', changes);
		// this.myControl = this.form.get(this.item.name) as FormControl;
		// this.filteredOptions = this.myControl.valueChanges.pipe(
		//   startWith(''),
		//   map(value => value ? this._filter(value) : this.item.options)
		// );
		// if (this.item.value !== undefined) {
		//   this.myControl.setValue(this.item.value);
		// }
	}
	onSelected($event: MatAutocompleteSelectedEvent): void {
		// console.log('+___+', $event);
		if ($event.option.value !== undefined && $event.option.value !== null && $event.option.value.toString().length > 0) {
			this.onchange.emit($event.option.value);
		}
	}
	handleEmptyInput($event: any): void {
		this.onchange.emit();
	}
	private _filter(value: string): object[] {
		const filterValue = typeof (value) === 'string' ? value.toLocaleLowerCase() : '';
		return this.item.options.filter(
			option => option.label.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) > -1
		);

	}
	public valueMapper = (key) => {
		const selection = this.item.options.find(e => e.data === key);
		if (selection) {
			return selection.label;
		}
	}
}
